/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MembershipHistoryItem interface.
 */
export function instanceOfMembershipHistoryItem(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('tierName' in value) || value['tierName'] === undefined)
        return false;
    if (!('tierDescription' in value) || value['tierDescription'] === undefined)
        return false;
    if (!('adherentFirstName' in value) || value['adherentFirstName'] === undefined)
        return false;
    if (!('adherentLastName' in value) || value['adherentLastName'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('orderDate' in value) || value['orderDate'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    if (!('season' in value) || value['season'] === undefined)
        return false;
    return true;
}
export function MembershipHistoryItemFromJSON(json) {
    return MembershipHistoryItemFromJSONTyped(json, false);
}
export function MembershipHistoryItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'tierName': json['tier_name'],
        'tierDescription': json['tier_description'],
        'adherentFirstName': json['adherent_first_name'],
        'adherentLastName': json['adherent_last_name'],
        'amount': json['amount'],
        'orderDate': (new Date(json['order_date'])),
        'state': json['state'],
        'season': json['season'],
    };
}
export function MembershipHistoryItemToJSON(json) {
    return MembershipHistoryItemToJSONTyped(json, false);
}
export function MembershipHistoryItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'tier_name': value['tierName'],
        'tier_description': value['tierDescription'],
        'adherent_first_name': value['adherentFirstName'],
        'adherent_last_name': value['adherentLastName'],
        'amount': value['amount'],
        'order_date': ((value['orderDate']).toISOString()),
        'state': value['state'],
        'season': value['season'],
    };
}
